import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useMutation } from "@apollo/client";
import Client from "gqlclient/Client";

const useValidateToken = (token, projectId) => {
  const [validatingToken, setValidatingToken] = useState(true);
  const [checkResetToken] = useMutation(Client.CHECK_RESET_TOKEN);
  const history = useHistory();
  const validatedRequest = useRef(null);

  useEffect(() => {
    if (!token || !projectId) return;

    const requestKey = `${projectId}:${token}`;
    if (validatedRequest.current === requestKey) return;
    validatedRequest.current = requestKey;

    setValidatingToken(true);
    checkResetToken(Client.CHECK_RESET_TOKEN_DEFAULT_OPTIONS(projectId, token))
      .then((res) => {
        if (
          res?.data?.checkResetToken === "invalidToken" ||
          res?.data?.checkResetToken === "expiredToken"
        ) {
          history.push("/forgotPassword", { from: "changePassword", error: "expiredToken" });
        }
      })
      .catch((error) => console.error("Error during checkResetToken", error))
      .finally(() => setValidatingToken(false));
  }, [checkResetToken, history, projectId, token]);

  return validatingToken;
};

export default useValidateToken;
